<template>
  <div>
    <content-container>
      <div class='digital-service'>
        <transition name='fade' mode='out-in'>
          <loader-with-message v-if='dataLoading'
                               key='loadersigurannet'
                               :has-error='dataFetchError'
                               @retry='fetchSiguranNetPackages' />
          <div v-else key='packagessigurannet'>
            <transition name='fade' mode='out-in'>
              <account-status-blocked v-if="userStatus === 'BLOCKED'" :key="'status-blocked'"
                                      :resources-data='$props.resourcesData' />
              <account-status-on-hold v-else-if="userStatus === 'ON_HOLD'" :key="'status-on-hold'"
                                      :resources-data='$props.resourcesData' />
              <div v-else key='status-active'>
                <base-heading>{{ $t('digitalServices.siguranNetDigitalServiceTitle') }}</base-heading>
                <div class='cards-container'>
                  <digital-service-card v-if='mainPackage'
                                        key='family package'
                                        :title='mainPackage.productName'
                                        :description='mainPackage.description'
                                        :logo='mainPackageImage'
                                        :price='mainPackageActualPrice'
                                        :activation-disabled='disableActions'
                                        :free-status='mainPackage.freeTrial'
                                        :limited-free-label='false'
                                        :old-price='mainPackageOldPrice'
                                        :service-active='mainPackage.active'
                                        recurring-price
                                        @activate-service='openConfirmationModal(mainPackage, packageTypes.main)'
                                        @deactivate-service='openConfirmationModal(mainPackage, packageTypes.main)' />
                  <digital-service-card v-if='juniorPackage'
                                        key='junior package'
                                        class='digital-service-card--big'
                                        :title='juniorPackage.productName'
                                        :description='juniorPackage.description'
                                        :logo='juniorPackageImage'
                                        :price='juniorPackageActualPrice'
                                        :activation-disabled='disableActions || !juniorPackage.canActivate'
                                        :free-status='juniorPackage.freeTrial'
                                        :limited-free-label='false'
                                        :old-price='juniorPackageOldPrice'
                                        recurring-price
                                        :hide-bottom-purchase-info='isAvailableContractsEmpty'
                                        @activate-service='openConfirmationModal(juniorPackage, packageTypes.junior)'
                                        @deactivate-service='openConfirmationModal(juniorPackage, packageTypes.junior)'>
                    <template #dropdown>
                      <div class='digital-card-dropdown-container' v-if='availableContracts.length'>
                        <p class='label'>{{ $t('digitalServices.siguranNet.contractLabel') }}</p>
                        <v-select class='select-dropdown'
                                  v-model='selectedContract'
                                  label='contractName'
                                  :options='availableContracts'
                                  :filterable='false'
                                  :searchable='false' />
                      </div>
                    </template>
                  </digital-service-card>
                </div>
              </div>
            </transition>
            <div v-if="userStatus !== 'BLOCKED' && userStatus !== 'ON_HOLD'" class='user-portal-button'
                 :class="{'user-portal-button--disabled': disableActions || !isMainPackageActivated}"
                 @click='goToWhaleBone()'>
              <div class='user-portal-button__info'>
                <div class='user-portal-button__title'>
                  {{ $t('digitalServices.siguranNet.userPortal.title') }}
                  <v-popover class='service-tooltip' popover-class='addon-popover' trigger='hover' placement='left'>
                    <img class='info-icon'
                         src='/assets/images/tooltip-info-16.png'
                         alt='info-icon'>
                    <template v-if='!(disableActions || !isMainPackageActivated)' slot='popover'>
                      <div class='addon-tooltip-description'>
                        {{ $t('digitalServices.siguranNet.userPortal.tooltip') }}
                      </div>
                    </template>
                  </v-popover>
                </div>
                <div class='user-portal-button__description'>
                  {{ $t('digitalServices.siguranNet.userPortal.description') }}
                </div>
              </div>
              <i class='icon-sc-chevron-right user-portal-button__icon'></i>
            </div>
            <purchase-history-table v-if='sigurannetActivatedPackages.length'
                                    :activated-packages='sigurannetActivatedPackages'
                                    :service='$props.serviceType'
                                    @deactivate='deactivateJuniorPackage' />
          </div>
        </transition>
      </div>
    </content-container>
    <div class='digital-service'>
      <!-- confirmation modal -->
      <confirmation-modal
        confirm-type='empty'
        :visible='sigurannetConfirmationModal'
        :closeButtonVisible='false'
        :cancel-button='true'
        :confirm-title='modalTexts.title'
        :confirm-description='modalTexts.description'
        :confirm-text='modalTexts.button'
        :loading='confirmationLoader'
        :button-disabled='buttonDisabled'
        @close='closeConfirmationModal()'
        @confirm='toggleActivation()' />
    </div>
  </div>
</template>
<script>

import DigitalServiceCard from '@/components/digital-services/digital-service-card'
import AccountStatusBlocked from '@/components/services/account-status/account-status-blocked'
import selectionBlockEvents from '@/mixins/selectionBlockEvents'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import ConfirmationModal from '@/components/common/modal/confirmation-modal'
import LoaderWithMessage from '@/components/common/loader-with-message'
import AccountStatusOnHold from '@/components/services/account-status/account-status-on-hold'
import PurchaseHistoryTable from '@/components/common/purchase-history/purchase-history-table'
import ContentContainer from '@/components/common/main-layout/content-container'
import i18n from '@/i18n'

export default {
  name: 'digital-service-siguran-net',
  components: {
    ContentContainer,
    PurchaseHistoryTable,
    AccountStatusOnHold,
    LoaderWithMessage,
    AccountStatusBlocked,
    DigitalServiceCard,
    ConfirmationModal
  },
  props: {
    resourcesData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    serviceType: {
      type: String,
      default: ''
    }
  },
  mixins: [selectionBlockEvents, errorMessageHandler],
  data () {
    return {
      dataLoading: true,
      dataFetchError: false,
      buttonDisabled: false, // button on modal window
      sigurannetAvailablePackages: [],
      selectedPackageType: '',
      selectedPackage: {},
      sigurannetActivatedPackages: [],
      selectedContract: {},
      availableContracts: [],
      disableActions: false,
      userStatus: '', // status for user to show info about blocking
      sigurannetConfirmationModal: false,
      confirmationLoader: false,
      msisdnForWhaleBone: '',
      packageTypes: {
        main: 'mainPackage',
        junior: 'juniorPackage'
      }
    }
  },
  computed: {
    mainPackage () {
      return this.sigurannetAvailablePackages?.[0] || []
    },
    isMainPackageActivated () {
      return this.mainPackage?.active
    },
    mainPackageActualPrice () {
      return this.mainPackage?.actualPrice?.formattedValue
    },
    mainPackageOldPrice () {
      return this.mainPackage?.originalPrice?.formattedValue || this.mainPackage?.actualPrice?.formattedValue
    },
    mainPackageImage () {
      return this.mainPackage?.image?.url
    },
    juniorPackage () {
      return this.sigurannetAvailablePackages?.[1] || {}
    },
    juniorPackageActualPrice () {
      return this.juniorPackage?.actualPrice?.formattedValue
    },
    juniorPackageOldPrice () {
      return this.juniorPackage?.originalPrice?.formattedValue || this.juniorPackage?.actualPrice?.formattedValue
    },
    juniorPackageImage () {
      return this.juniorPackage?.image?.url
    },
    modalTexts () {
      const isActivation = !this.selectedPackage.active

      if (this.selectedPackageType === this.packageTypes.main && isActivation) { // if main and activation process
        return {
          title: i18n.tc('digitalServices.siguranNet.activationModalMain.title'),
          button: i18n.tc('common.activate')
        }
      } else if (this.selectedPackageType === this.packageTypes.main && !isActivation) { // if main and deactivation process
        return {
          title: i18n.tc('digitalServices.siguranNet.deactivationModalMain.title'),
          description: i18n.tc('digitalServices.siguranNet.deactivationModalMain.description'),
          button: i18n.tc('common.deactivate')
        }
      } else if (this.selectedPackageType === this.packageTypes.junior && isActivation) { // if junior and activation process
        return {
          title: i18n.tc('digitalServices.siguranNet.activationModalJunior.title'),
          button: i18n.tc('common.activate')
        }
      } else { // if junior and deactivation process
        return {
          title: i18n.tc('digitalServices.siguranNet.deactivationModalJunior.title'),
          button: i18n.tc('common.deactivate')
        }
      }
    },
    isAvailableContractsEmpty () {
      return !this.availableContracts.length
    }
  },
  methods: {
    fetchSiguranNetPackages () {
      if (this.$props.resourcesData.subscriptionInfo && this.$props.resourcesData.subscriptionInfo.customerId) {
        this.dataLoading = true
        this.dataFetchError = false
        this.blockSidebarSelection()
        const customerId = this.$props.resourcesData.subscriptionInfo.customerId
        this.$apiRequest.get(`user/sigurannet/info?customerId=${customerId}`)
          .then(response => {
            this.sigurannetAvailablePackages = response.data.available || []
            this.sigurannetActivatedPackages = response.data.activated || []
            this.disableActions = response.data.disableActions
            this.availableContracts = response.data.available?.[1]?.availableContracts || []
            this.selectedContract = this.availableContracts[0]
            this.userStatus = response.data.contractStatus
            this.msisdnForWhaleBone = response.data.msisdnForWhaleBone || ''
            this.dataLoading = false
          })
          .catch(e => {
            this.dataFetchError = true
          })
          .finally(() => {
            this.unblockSidebarSelection()
          })
      }
    },
    deactivateJuniorPackage (activatedJuniorPackage) {
      this.selectedContract = activatedJuniorPackage
      this.openConfirmationModal(activatedJuniorPackage, this.packageTypes.junior)
    },
    openConfirmationModal (selectedPackage, type) {
      this.selectedPackageType = type
      this.selectedPackage = selectedPackage
      this.sigurannetConfirmationModal = true
    },
    closeConfirmationModal () {
      this.selectedPackage = {}
      this.sigurannetConfirmationModal = false
    },
    toggleActivation () {
      this.buttonDisabled = true
      this.confirmationLoader = true
      const id = this.$props.resourcesData.subscriptionInfo.customerId
      const isMain = this.selectedPackage?.productName === this.mainPackage?.productName
      const dataToSend = {
        customerId: isMain ? id : (this.selectedContract.contractId || this.selectedPackage.contractId),
        activate: !this.selectedPackage.active,
        isMain,
        ...(!this.selectedPackage.active && { parentCustomerId: id })
      }
      this.$apiRequest.post('user/sigurannet', dataToSend)
        .then(response => {
          if (response.status === 200) {
            this.sigurannetConfirmationModal = false
            this.toast('success', {
              title: dataToSend.activate
                ? this.$t('digitalServices.siguranNet.successfulActivationNotification.title')
                : this.$t('digitalServices.siguranNet.successfulDeactivationNotification.title')
            })
            this.fetchSiguranNetPackages()
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.buttonDisabled = false
          this.confirmationLoader = false
        })
    },
    goToWhaleBone () {
      this.$apiRequest.get(`user/securenet/filtertraffic?msisdn=${this.msisdnForWhaleBone}`)
        .then(response => {
          if (response.status === 200) {
            window.location.href = response.data
          }
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchSiguranNetPackages()
    })
  }
}
</script>

<style scoped lang='scss' src='./styles/digital-service-page.scss'></style>
